import React from "react";
import { Link } from "react-router-dom";
import { useBreadcrumb } from "../hooks/useBreadcrumb";
import "../styles/Breadcrumb.css";

const HomeIcon = () => (
  <svg
    className="w-3.5 h-3.5"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
    />
  </svg>
);

const ChevronIcon = () => (
  <svg
    className="w-3 h-3 text-[var(--color-text-tertiary)] opacity-40"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
      d="M9 5l7 7-7 7"
    />
  </svg>
);

export default function Breadcrumb() {
  const breadcrumbs = useBreadcrumb();

  if (breadcrumbs.length === 0) {
    return null;
  }

  // Логика сокращения хлебных крошек для мобильных устройств
  const renderBreadcrumbs = () => {
    if (breadcrumbs.length <= 2) return breadcrumbs;

    // На мобильных показываем первую (иконку дома) и последние две
    const isMobile = typeof window !== "undefined" && window.innerWidth < 640;
    if (isMobile && breadcrumbs.length > 2) {
      return [
        { label: "...", path: "#", current: false, isEllipsis: true },
        breadcrumbs[breadcrumbs.length - 2],
        breadcrumbs[breadcrumbs.length - 1],
      ];
    }
    return breadcrumbs;
  };

  const visibleCrumbs = renderBreadcrumbs();

  return (
    <nav className="breadcrumb-nav" aria-label="Breadcrumb">
      <ol className="breadcrumb-container">
        <li className="breadcrumb-item">
          <Link
            to="/dashboard"
            className="breadcrumb-home-link"
            title="Главная"
          >
            <HomeIcon />
          </Link>
        </li>

        {visibleCrumbs.map((crumb, index) => (
          <React.Fragment key={`breadcrumb-${index}`}>
            <li className="breadcrumb-separator-item">
              <ChevronIcon />
            </li>
            <li className="breadcrumb-item">
              {crumb.isEllipsis ? (
                <span className="breadcrumb-ellipsis">...</span>
              ) : crumb.current ? (
                <span className="breadcrumb-active-text">{crumb.label}</span>
              ) : (
                <Link to={crumb.path} className="breadcrumb-nav-link">
                  {crumb.label}
                </Link>
              )}
            </li>
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
}
